import { CustomSelect } from '@amili-v3/amili-v3-design';
import styled from 'styled-components';

export const SwitchLanguageButtonWrapper = styled.div`
  width: 46px;
  right: 16px;
  top: 12px;
  /* z-index: 1200; */
`;

export const SwitchLanguageSelect = styled(CustomSelect)`
  width: 100%;
  &.switch-language-select.custom-select.ant-select:not(
      .ant-select-disabled,
      .ant-select-status-error
    ):not(.ant-select-customize-input):not(.ant-select-multiple) {
    .ant-select-selector {
      border: none;
      background: transparent;
      padding: 0;
      cursor: pointer;
    }
    .ant-select-selection-item {
      font-size: 16px;
      font-weight: 600;
      color: var(--primary);
    }
    .ant-select-arrow {
      inset-inline-end: 6px;
    }

    &:is(.ant-select-open, .ant-select-focused).ant-select:not(
        .ant-select-disabled
      ):not(.ant-select-customize-input):not(.ant-pagination-size-changer)
      .ant-select-selector {
      box-shadow: 0 0 0 2px transparent;
    }
    &.fixed .ant-select-selection-item {
      color: white;
    }

    @media (max-width: 1200px) {
      .ant-select-selection-item {
        font-size: 14px;
      }
    }
  }
`;

// export const SwitchLanguageSelect = styled(CustomSelect)`
//   &.switch-language-select {
//     .ant-select-selector {
//       padding: 0;
//     }
//     .ant-select-selection-item {
//       /* padding-right: 30px; */
//     }
//     .ant-select-arrow {
//       inset-inline-end: 0;
//     }
//     .ant-select-selection-item,
//     .ant-select-selector {
//       /* padding: 0; */
//       background: transparent;
//       border: none;
//       outline: none;
//       color: var(--primary);
//       font-weight: 600;
//       font-size: 16px;
//       &:not(.ant-select-disabled):not(.ant-select-customize-input):hover {
//         border: none;
//       }
//     }
//     &:is(.ant-select-open, .ant-select-focused).ant-select:not(
//         .ant-select-disabled
//       ):not(.ant-select-customize-input):not(.ant-pagination-size-changer)
//       .ant-select-selector {
//       box-shadow: 0 0 0 2px transparent;
//     }
//     &.fixed .ant-select-selection-item {
//       color: white;
//     }
//   }
// `;
